module.exports = __webpack_public_path__ + "img/设计图片示例2.66a340e6.png";